import React from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';

import { ReturnRow } from 'types/ReturnTable';
import { useAppDispatch } from 'reducers';
import { getReasonCodes } from 'reducers/reasonCodesDB';
import { REASONS } from 'constants/reasonCodesDB';
import ReasonCodesInput from 'components/inputs/ReasonCodesInput';

import { setRowReasonID } from '../../utils';
import { AdditionalFieldsBox } from '../styled';

import AmountInput from './AmountInput';

type Props = {
  row: ReturnRow;
};

const AdditionalFields: React.FC<Props> = ({ row }) => {
  const dispatch = useAppDispatch();
  const reasonCodes = useSelector(getReasonCodes(REASONS.RETURN));
  const noReasonCodes = reasonCodes.length === 0;
  if (!row.selected) return null;
  if (noReasonCodes && row.originalAmount === 1) return null;

  return (
    <AdditionalFieldsBox container spacing={2}>
      {row.originalAmount > 1 ? (
        <Grid item sm={noReasonCodes ? 12 : 6} xs={12}>
          <AmountInput row={row} />
        </Grid>
      ) : null}
      {noReasonCodes ? null : (
        <Grid item sm={row.originalAmount > 1 ? 6 : 12} xs={12}>
          <ReasonCodesInput
            size="small"
            value={row.returnReasonID}
            reasonCodes={reasonCodes}
            onChange={e => dispatch(setRowReasonID(row, e.target.value))}
            data-testid="product-row-return-reasons"
          />
        </Grid>
      )}
    </AdditionalFieldsBox>
  );
};

export default AdditionalFields;
